import axios from 'axios';
import { establishRefreshSession, revokeAuthSession } from "./auth-session.service";
import { clearAuthTokens, setAccessToken } from "./token.service";

const API_URL = process.env.VUE_APP_API_BASE_URL;

const headers = {
  Accept: "application/vnd.api+json",
  "Content-Type": "application/vnd.api+json",
};

async function login(user) {
  const requestHeaders = {
    'Content-Type': 'application/json' // Ensure this header is set
  };

  const response = await axios.post(API_URL + '/login', {
    email: user.email,
    password: user.password
  }, { headers: requestHeaders });

  if (response.data.access_token) {
    try {
      setAccessToken(response.data.access_token);
      await establishRefreshSession({ accessToken: response.data.access_token });
    } catch (error) {
      clearAuthTokens();
      console.error("[auth.service] Login failed: refresh session issuance failed", error);
      throw error;
    }
    await new Promise(resolve => setTimeout(resolve, 450));
    // Avoid importing router here to prevent circular module init in production bundle.
    if (typeof window !== "undefined" && window.__protegoRouter) {
      window.__protegoRouter.push({ name: "Home" });
    } else if (typeof window !== "undefined") {
      window.location.assign("/dashboard/home");
    }
  }
  return response.data;
}

async function getBizAssureLoginUrl(options = {}) {
  const params = {};

  if (options.targetOrigin) {
    params.target_origin = options.targetOrigin;
  }

  if (options.returnTo) {
    params.return_to = options.returnTo;
  }

  const response = await axios.get(`${API_URL}/bizassure/login-url`, {
    params,
    headers: {
      "Content-Type": "application/json",
    },
  });

  return response.data;
}


async function logout() {
  await revokeAuthSession();
}

async function register(user) {

  const response = await axios.post(API_URL + '/register',
    {
      name: user.name,
      email: user.email,
      password: user.password,
      password_confirmation: user.confirm_password,
    }, { headers });

  if (response.data.access_token) {
    try {
      setAccessToken(response.data.access_token);
      await establishRefreshSession({ accessToken: response.data.access_token });
    } catch (error) {
      clearAuthTokens();
      console.error("[auth.service] Registration failed: refresh session issuance failed", error);
      throw error;
    }
  }
  return response.data;
}

async function establishSession(accessToken) {
  if (!accessToken || typeof accessToken !== "string") {
    throw new Error("A valid access token is required.");
  }

  try {
    setAccessToken(accessToken);
    return await establishRefreshSession({ accessToken });
  } catch (error) {
    clearAuthTokens();
    console.error("[auth.service] Session establishment failed: refresh session issuance failed", error);
    throw error;
  }
}

async function forgotPassword(data) {
  await axios.post(API_URL + '/password-forgot', data, { headers });
}

async function validateResetPasswordToken(data) {
  const response = await axios.get(API_URL + '/password-reset/validate', {
    params: data,
    headers
  });

  return response.data;
}

async function resetPassword(data) {
  await axios.post(API_URL + '/password-reset', data, { headers });
}

export default {
  login,
  getBizAssureLoginUrl,
  logout,
  register,
  forgotPassword,
  validateResetPasswordToken,
  resetPassword,
  establishSession
};
